export const CacheProvider = {
  generateKey: (prefix, data) => {
    let dataString = '';
    if (data) {
      if (typeof data === 'object') {
        dataString = JSON.stringify(data);
      } else {
        dataString = data.toString();
      }
    }
    return window.btoa(encodeURIComponent(`${prefix}_${dataString}`));
  },
  set: (key, value) => {
    if (typeof value === 'object') {
      value = JSON.stringify(value);
    }

    window.sessionStorage.setItem(key, value);
  },
  get: key => {
    let cachedValue, paredResult;

    cachedValue = window.sessionStorage.getItem(key);

    try {
      paredResult = JSON.parse(cachedValue);
    } catch (e) {
      paredResult = cachedValue;
    }

    return paredResult;
  },
  clear: () => {
    window.sessionStorage.clear();
  }
};
